var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg2 = function Svg2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#003E52",
    d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.536 19.93q.607-.441.553-.408a65 65 0 0 0 2.75-2.169 10.6 10.6 0 0 0 1.715-1.777q.696-.93.696-1.81 0-.668-.34-1.043-.339-.375-1.017-.375-.68 0-1.072.473-.375.456-.375 1.304H11.5q.036-1.386.643-2.315a3.74 3.74 0 0 1 1.625-1.37q1.017-.44 2.25-.44 2.125 0 3.196.995 1.09.995 1.09 2.592 0 1.745-1.304 3.244-1.303 1.484-3.321 2.903H20.5V22h-8.964z"
  })));
};
export default Svg2;